import {remCalc} from '_themeUtils'
import {keyframes} from '@emotion/react'

const buttonAnimation = keyframes`
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(8px);
    }
`

const scrollDownButton = {
    ScrollDownButton: {
        baseStyle: ({arrowColor = 'white'} = {}) => ({
            wrapper: {
                display: 'block',
                position: 'absolute',
                bottom: {base: 'spacing.20', md: 'spacing.16', lg: 'spacing.6'},
                left: '50%',
                marginLeft: '-spacing.8',
                zIndex: 8,
                cursor: 'pointer',
                p: 'spacing.2',
                color: arrowColor,
                background: 'color.background.transparent',
                _hover: {
                    color: arrowColor,
                },
                '& > button': {
                    background: 'color.background.transparent',
                },
            },
            svg: {
                display: 'block',
                minW: remCalc(50),
                maxW: remCalc(50),
                minH: remCalc(50),
                maxH: remCalc(50),
                stroke: arrowColor,
                fill: arrowColor,
                color: arrowColor,
                _hover: {
                    color: arrowColor,
                },
                // animationName: `${buttonAnimation}`,
                // animationDuration: '1s',
                // animationTimingFunction: 'ease-in-out',
                // animationDelay: '0s',
                // animationDirection: 'alternate',
                // animationIterationCount: 'infinite',
            },
        }),
    },
}

export default scrollDownButton
